import React from 'react'
import Columns from 'react-columns'
import PropTypes from 'prop-types'

class MasonryLayout extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      heights: []
    }
  }

  render () {
    let queries = [
      {
        columns: 1,
        query: 'min-width: 768px'
      },
      {
        columns: 2,
        query: 'min-width: 992px'
      },
      {
        columns: 3,
        query: 'min-width: 1200px'
      }
    ]

    return (
      <Columns queries={queries} className='masonry-layout'>
        {this.props.children}
      </Columns>
    )
  }
}

MasonryLayout.propTypes = {
  children: PropTypes.node
}

export default MasonryLayout
